/**
 * @return {String} PROCESS_ENVIRONMENTS
 * The available process Environments
 */
export const PROCESS_ENVIRONMENTS = {
  PRODUCTION: 'production',
  DEVELOPMENT: 'development',
  TEST: 'testing'
}

/**
 * @return {String} PROCESS_ENVIRONMENT
 * The currently used process Environment
 */
export const PROCESS_ENVIRONMENT = process.env.NODE_ENV

/**
 * @return {String} API_ROOT
 * The Root URL for back-end calls
 */
export const API_ROOT = process.env.VUE_APP_API_ROOT

/**
 * @return {String} COOKIE_DOMAIN
 * What domain to use in the cookies
 */
export const COOKIE_DOMAIN = process.env.VUE_APP_COOKIE_DOMAIN

/**
 * @return {Boolean} USE_MOCK_DATA
 * Whether API calls should return real or mock data
 */
export const USE_MOCK_DATA = process.env.VUE_APP_USE_MOCK_DATA

/**
 * @return {Number} LOG_LEVELS
 * The available Log Levels
 */
export const LOG_LEVELS = {
  TEST: 0,
  DEBUG: 1,
  ERROR: 2
}

/**
 * @return {Number} LOG_LEVEL
 * The currently used Log Level
 */
export const LOG_LEVEL = process.env.VUE_APP_LOG_LEVEL

/**
 * @return {String} API_APPS
 * The URLs for the different front-end APPs
 */
export const API_APPS = {
  PUBLIC: process.env.VUE_APP_PUBLIC_URL,
  CUSTOMER: process.env.VUE_APP_CUSTOMER_URL,
  ADMINISTRATOR: process.env.VUE_APP_ADMINISTRATOR_URL,
  AUDITOR: process.env.VUE_APP_AUDITOR_URL,
  MANAGER: process.env.VUE_APP_MANAGER_URL,
  HR: process.env.VUE_APP_HR_URL
}

/**
 * @return {Number} PROFILE_TYPES
 * The identifiers for the different Profile Types
 */
export const PROFILE_TYPES = {
  MANAGER: 1,
  AUDITOR: 2,
  ADMINISTRATOR: 3,
  CUSTOMER: 4,
  HR: 5
}

/**
 * @return {String} CASE_STATES
 * The identifiers for the different Case States
 */
export const CASE_STATES = {
  ACTION_REQUIRED: 'Action Required',
  DONE: 'Done',
  ASSIGNING_REVIEWER: 'Assigning Reviewer',
  IN_REVIEW: 'In Review'
}

/**
 * @return {String} ROUTER_MODE
 * The router mode can be set here
 */

export const ROUTER_MODE = process.env.VUE_APP_ROUTER_MODE
